<template>
  <section>
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
      <div>
        <div class="box-header">
          <h3 class="box-title" style="color: white">Trip Details</h3>
          <div v-if="trip.status=='ongoing'">
            <span
              class="label label-success mr-5"
              style="float:right;font-size: 134%;font-weight: 500;height: 28px;width: 139px;margin-right:20px;margin-top:-20px;"
            >Ongoing Trips</span>
          </div>
          <div v-else-if="trip.status=='completed'">
            <span
              class="label label-primary mr-5"
              style="float:right;font-size: 134%;font-weight: 500;height: 28px;width: 156px;margin-top: -20px;"
            >Completed Trips</span>
          </div>
          <div v-else-if="trip.status=='halt'">
            <span
              class="label label-danger mr-5"
              style="float:right;font-size: 134%;font-weight: 500;height: 28px;width: 139px;margin-top: -20px;"
            >Halt Trips</span>
          </div>
          <div v-else-if="trip.status=='scheduled'">
            <span
              class="label label-warning mr-5"
              style="float:right;font-size: 134%;font-weight: 500;height: 28px;width: 153px;margin-top: -20px;"
            >Scheduled Trips</span>
          </div>
        </div>
        <div class="box-body">
          <div class="row">
            <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
              <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
            </div>
          </div>
          <div v-if="trip.status=='ongoing'" style="float:right">
            <span class="btn btn-default" @click="tripEnd('cancel')">Cancel Trip</span>
            <span
              class="btn btn-default"
              data-toggle="modal"
              data-target="#exampleModal"
              @click="EditTrip()"
            >Update Trip</span>
            <span class="btn btn-danger" style="margin-right:10px" @click="tripEnd('end')">End Trip</span>
          </div>
          <div v-if="trip.status=='completed'" style="float:right">
            <span
              class="btn btn-default"
              data-toggle="modal"
              data-target="#exampleModal"
              @click="EditTrip()"
            >Update Trip</span>
          </div>
          <div id="details">
            <div class="row">
              <div class="col-md-12">
                <label style="margin-left:20px">Trip Code : {{trip.tripCode}}</label>
              </div>
            </div>
            <div class="row trip-detail-tbl">
              <div class="col-md-6">
                <table class="table table-bordered">
                  <tr>
                    <th>From - To :</th>
                    <td>{{trip.startSiteSiteName}} - {{trip.endSiteSiteName}}</td>
                  </tr>
                  <tr>
                    <th>Scheduled Time :</th>
                    <td>{{trip.scheduleTime}}</td>
                  </tr>
                  <tr>
                    <th>Vehicle Registration No :</th>
                    <td>{{ trip.vehicleIdRegNo }}</td>
                  </tr>
                  <tr>
                    <th>Scheduled Date :</th>
                    <td>{{this.scheduledDate}}</td>
                  </tr>
                  <tr>
                    <th>Driver Name :</th>
                    <td>{{trip.driverIdDriverName}}</td>
                  </tr>
                  <tr>
                    <th>Device ID :</th>
                    <td>{{trip.deviceIdImei}}</td>
                  </tr>
                </table>
              </div>
              <div class="col-md-6">
                <table class="table table-bordered">
                  <tr>
                    <th
                      colspan="2"
                      style="font-size: 17px;color: #3c8dbc;"
                    >At {{trip.startSiteSiteName}}</th>
                  </tr>
                  <tr>
                    <th>HCV reached origin At (Waiting Started At) :</th>
                    <td>{{this.originReached}}</td>
                  </tr>
                  <tr>
                    <th>Trip Started At :</th>
                    <td>{{this.startedDate}}</td>
                  </tr>

                  <tr>
                    <th
                      colspan="2"
                      style="font-size: 17px;color: #3c8dbc;"
                    >At {{trip.endSiteSiteName}}</th>
                  </tr>
                  <tr>
                    <th>HCV reached Destination At (Idling Started At) :</th>
                    <td>{{this.destinationReached}}</td>
                  </tr>
                  <tr>
                    <th>Trip Completed At :</th>
                    <td>{{(this.endedDate)}}</td>
                  </tr>
                </table>
              </div>
            </div>

            <div class="row" v-if="trip.status == 'ongoing' || trip.status == 'completed'">
              <div class="col-md-6" style="text-align:center">
                <a
                  class="btn dropdown-toggle"
                  data-toggle="collapse"
                  href="#odometer"
                  role="button"
                  aria-expanded="false"
                  aria-controls="odometer"
                  style="color:white"
                >Odometer Details</a>
              </div>
              <div class="col-md-6" style="text-align:center">
                <a
                  class="btn dropdown-toggle"
                  data-toggle="collapse"
                  href="#gasfilling"
                  role="button"
                  aria-expanded="false"
                  aria-controls="gasfilling"
                  style="color:white"
                >Gas Flow Meter Detail</a>
              </div>
              <!-- <div class="col-md-4">
                <a
                  class="btn dropdown-toggle"
                  data-toggle="collapse"
                  href="#pressure"
                  role="button"
                  aria-expanded="false"
                  aria-controls="pressure"
                  style="color:white"
                >Pressure Detail</a>
              </div>-->
            </div>
            <div id="odometer" class="container collapse" style="width:auto">
              <div>
                <h4 class="text-center">
                  <b>Odometer Details</b>
                </h4>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Image</th>
                      <th>Trip Type</th>
                      <th>Latitude</th>
                      <th>Longitude</th>
                      <th>Meter Reading</th>
                      <th>RecordedTime</th>
                      <th>Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="o in this.odometer ">
                      <td>
                        <div v-for="imgs1 in o.image">
                          <a
                            :href="`${i_url}${o.tripID}/${o.tripType}/${o.imageType}/${o.captureType}/${imgs1}`"
                            target="_blank"
                          >
                            <img
                              :src="`${i_url}${o.tripID}/${o.tripType}/${o.imageType}/${o.captureType}/${imgs1}`"
                              style="height:50px; margin:2px; width:50px"
                              alt="Not Available"
                            />
                          </a>
                          <br />
                        </div>
                      </td>
                      <td>{{o.tripType == 'startTrip' ? trip.startSiteSiteType : trip.endSiteSiteType}}</td>
                      <td>{{o.latitude}}</td>
                      <td>{{o.longitude}}</td>
                      <td>{{o.meterReading}}</td>
                      <td>{{o.recordedTime}}</td>
                      <td>
                        <a role="button" class="icons" @click="openUpdateTripDia(o)">
                          <i class="fa fa-edit" aria-hidden="true" v-tooltip="'edit details'"></i>
                        </a>
                        &nbsp;
                        <a
                          role="button"
                          class="icons"
                          @click="deleteTripDetail(o)"
                        >
                          <i class="fa fa-trash" aria-hidden="true" v-tooltip="'delete details'"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style="float:right">
                  <button
                    type="submit"
                    @click="openNewTripDia()"
                    v-if="this.odometer.length < 2"
                  >Add Odometer Details</button>
                </div>
              </div>
              <div
                v-if="this.startOdoMeterReading.length>0 && this.endOdoMeterReading.length>0 && this.endOdoMeterReading[this.endOdoMeterReading.length-1].meterReading && this.startOdoMeterReading[this.startOdoMeterReading.length-1].meterReading"
              >
                <h5>
                  <b>Distance Travel from {{trip.startSiteSiteType}} to {{trip.endSiteSiteType}} is {{(this.endOdoMeterReading[this.endOdoMeterReading.length-1].meterReading-this.startOdoMeterReading[this.startOdoMeterReading.length-1].meterReading).toFixed(2)}} km</b>
                </h5>
              </div>
              <div v-if="this.startOdoMeterReading.length>0 && this.endOdoMeterReading.length==0">
                <h5>
                  <b>Distance Travel from {{trip.startSiteSiteType}} to {{trip.endSiteSiteType}} is 0 km</b>
                </h5>
              </div>
              <div
                v-if="this.startOdoMeterReading.length==0 && this.endOdoMeterReading.length>0 && this.endOdoMeterReading[this.endOdoMeterReading.length-1].meterReading"
              >
                <h5>
                  <b>Distance Travel from {{trip.startSiteSiteType}} to {{trip.endSiteSiteType}} is {{(this.endOdoMeterReading[this.endOdoMeterReading.length-1].meterReading-0).toFixed(2)}} km</b>
                </h5>
              </div>
              <div v-if="this.startOdoMeterReading.length==0 && this.endOdoMeterReading.length==0">
                <h5>
                  <b>Distance Travel from {{trip.startSiteSiteType}} to {{trip.endSiteSiteType}} is 0 km</b>
                </h5>
              </div>
              <div v-if="this.startRecordedTime.length>0 && this.endRecordedTime.length>0">
                <h5>
                  <b>Travel time from {{trip.startSiteSiteType}} to {{trip.endSiteSiteType}} is {{this.timeDifference}} sec</b>
                </h5>
              </div>
            </div>
            <div id="gasfilling" class="container collapse" style="width:auto">
              <div>
                <h4 class="text-center">
                  <b>Gas Flow Meter Details</b>
                </h4>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Challan Image</th>
                      <th>Trip Type</th>
                      <th>Capture Type</th>
                      <th>Pressure Gauge Reading</th>
                      <th>Gas Flow Meter Reading</th>
                      <th>RecordedTime</th>
                      <th>Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="gs in this.reportData">
                      <td>
                        <div v-if="gs.reading_1 == 'startTrip' && gs.reading_2 == 'post'">
                          <a
                            :href="`${challan_img_url}/${urlId}/startTrip/challan/pre/${challanImage}`"
                            target="_blank"
                          >
                            <img
                              :src="`${challan_img_url}/${urlId}/startTrip/challan/pre/${challanImage}`"
                              style="height:50px; margin:2px; width:50px"
                              alt="Not Available"
                            />
                          </a>
                        </div>
                      </td>
                      <td>{{gs.reading_1 == "startTrip"? trip.startSiteSiteType: trip.endSiteSiteType}}</td>
                      <td>{{gs.reading_2 == "pre" ? 'Initial':'Final'}}</td>
                      <td>{{gs.reading_3 ? gs.reading_3 : ''}}</td>
                      <td>{{gs.reading_4 ? gs.reading_4:''}}</td>
                      <td>{{gs.reading_5? gs.reading_5 : ''}}</td>
                      <td style="text-align:center">
                        <a role="button" class="icons" @click="openUpdateGasFlowDia(gs)">
                          <i class="fa fa-edit" aria-hidden="true" v-tooltip="'edit details'"></i>
                        </a> &nbsp;
                        <a
                          role="button"
                          class="icons"
                          @click="deleteopenUpdateGasFlowDia(gs)"
                        >
                          <i class="fa fa-trash" aria-hidden="true" v-tooltip="'delete details'"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style="float:right">
                  <button
                    type="submit"
                    @click="openNewGasFlowDia()"
                    v-if="this.reportData.length < 4"
                  >Add Gas Flow Meter Details</button>
                </div>
              </div>
              <div
                v-if="this.postStartGas.length >0 && this.preStartGas.length >0 && this.postStartGas[this.postStartGas.length-1].meterReading && this.preStartGas[this.preStartGas.length-1].meterReading"
              >
                <h5>
                  <b>Gas Flow Meter Difference at {{trip.startSiteSiteType}} is {{(this.postStartGas[this.postStartGas.length-1].meterReading-this.preStartGas[this.preStartGas.length-1].meterReading).toFixed(2)}}</b>
                </h5>
              </div>
              <div
                v-if="this.postStartGas.length >0 && this.preStartGas.length==0 && this.postStartGas[this.postStartGas.length-1].meterReading"
              >
                <h5>
                  <b>Gas Flow Meter Difference at {{trip.startSiteSiteType}} is {{(this.postStartGas[this.postStartGas.length-1].meterReading-0).toFixed(2)}}</b>
                </h5>
              </div>
              <div
                v-if="this.preStartGas.length >0 && this.postStartGas.length==0 && this.preStartGas[this.postStartGas.length-1].meterReading"
              >
                <h5>
                  <b>Gas Flow Meter Difference at {{trip.startSiteSiteType}} is {{(0-this.preStartGas[this.postStartGas.length-1].meterReading).toFixed(2)}}</b>
                </h5>
              </div>
              <div
                v-if="this.postEndGas.length >0 && this.preEndGas.length >0 && this.postEndGas[this.postEndGas.length-1].meterReading && this.preEndGas[this.preEndGas.length-1].meterReading "
              >
                <h5>
                  <b>Gas Flow Meter Difference at {{trip.endSiteSiteType}} is {{(this.postEndGas[this.postEndGas.length-1].meterReading-this.preEndGas[this.preEndGas.length-1].meterReading).toFixed(2)}}</b>
                </h5>
              </div>
              <div
                v-if="this.postEndGas.length >0 && this.preEndGas.length ==0 && this.postEndGas[this.postEndGas.length-1].meterReading"
              >
                <h5>
                  <b>Gas Flow Meter Difference at {{trip.endSiteSiteType}} is {{(this.postEndGas[this.postEndGas.length-1].meterReading).toFixed(2)}}</b>
                </h5>
              </div>
              <div
                v-if="this.postEndGas.length ==0 && this.preEndGas.length >0 && this.preEndGas[this.preEndGas.length-1].meterReading"
              >
                <h5>
                  <b>Gas Flow Meter Difference at {{trip.endSiteSiteType}} is {{(0-this.preEndGas[this.preEndGas.length-1].meterReading).toFixed(2)}}</b>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <div class="tab" v-if="trip.status =='ongoing' || trip.status== 'completed'">
        <button class="tablinks btn" style="color:white" @click="exceptionTable">Show Exceptions</button>
        <button class="tablinks btn" style="color:white" @click="locationLogTable">Trip Details</button>
        <router-link :to="{ name: 'Trip' }">
          <button class="mr-5 btn btn-default" type="button">Cancel</button>
        </router-link>
      </div>
      <div class="col-sm-12 text-right" v-if="trip.status =='scheduled' || trip.status== 'halt'">
        <router-link :to="{ name: 'TripDetail' } ">
          <button class="mr-5 btn btn-default" type="button">Cancel</button>
        </router-link>
      </div>
      <div id="exceptionTable" class="tabcontent" style="display: none; margin-top :10px">
        <div>
          <div class="box-header">
            <h3 class="box-title" style="color:white">Trip Exception</h3>
          </div>
          <div class="box-body">
            <div :class="addButtonClass"></div>
            <div>
              <v-server-table
                ref="tripExceptionTable"
                url
                :columns="columns"
                :options="options"
                @loaded="onLoaded"
              >
                <template slot="beforeBody">
                  <tr v-if="loading" class="VueTables__no-results">
                    <td class="text-center" colspan="6">
                      <pulse-loader></pulse-loader>
                    </td>
                  </tr>
                </template>
              </v-server-table>
            </div>
          </div>
        </div>
      </div>
      <div>
        <TripLocationLog
          id="tripLocationLogTable"
          class="tabcontent"
          style="display: none; margin-top :10px"
        ></TripLocationLog>
      </div>
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document" style="width: 50%">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <table class="table table-bordered">
                <tr style="marginTop:10px">
                  <th>HCV reached origin At (Waiting Started At) :</th>
                  <td>
                    <datetime type="datetime" v-model="trip.originReachedAt" use12-hour></datetime>
                  </td>
                </tr>
                <tr style="marginTop:10px">
                  <th>Trip Started At :</th>
                  <td>
                    <datetime type="datetime" v-model="trip.startDate" use12-hour></datetime>
                  </td>
                </tr>
                <tr style="marginTop:10px">
                  <th>HCV reached Destination At (Idling Started At) :</th>
                  <td>
                    <datetime type="datetime" v-model="trip.destinationReachedAt" use12-hour></datetime>
                  </td>
                </tr>
                <tr style="marginTop:10px">
                  <th>Trip Completed At :</th>
                  <td>
                    <datetime type="datetime" v-model="trip.endDate" use12-hour></datetime>
                  </td>
                </tr>
                <tr v-if="trip.status == 'ongoing'">
                  <th>Change Trip Status</th>
                  <td>
                    <select class="form-control" @change="changeStatus" v-model="statusValue">
                      <option value="completed">Completed</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                  </td>
                </tr>
              </table>
              <div class="text-right" style="margin-top:20px">
                <button class="btn btn-primary" @click="tripEnd('update')">Save</button>
              </div>
            </div>
            <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>-->
          </div>
        </div>
      </div>
    </div>

    <modal name="tripDialog" height="425">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
          <b>{{edit.title}}</b>
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="$modal.hide('tripDialog'); refreshTab();                                          "
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </h4>
      </div>

      <div class="modal-body">
        <table style="width:100%">
          <tr>
            <td>
              <label style="float: left">Trip Type:</label>
            </td>

            <td>
              <select v-model="edit.tripType">
                <option value="startTrip">Origin</option>
                <option value="endTrip">Destination</option>
              </select>
            </td>
          </tr>
          <br />
          <tr>
            <td>
              <label style="float: left">Latitude:</label>
            </td>
            <td>
              <input type="number" v-model="edit.latitude" />
            </td>
          </tr>
          <br />
          <tr>
            <td>
              <label style="float: left">Longitude:</label>
            </td>
            <td>
              <input type="number" v-model="edit.longitude" />
            </td>
          </tr>
          <br />
          <tr>
            <td>
              <label style="float: left">Meter Reading:</label>
            </td>
            <td>
              <input type="number" v-model="edit.meterReading" />
            </td>
          </tr>
          <br />
          <tr>
            <td>
              <label style="float: left">Recorded Time:</label>
            </td>
            <td>
              <datetime type="datetime" v-model="edit.recordedTime" use12-hour></datetime>
            </td>
          </tr>

          <br />

          <tr>
            <div v-if="edit.title=='Create trip'">
              <td>
                <label style="float: left">Image:</label>
              </td>
              <td>
                <input type="file" @change="onFilechanged" class="form-control" name="image" />
                <field-messages name="image" class="form-control-feedback"></field-messages>
              </td>

              <br />
            </div>
          </tr>

          <!-- 
        <div v-for="imgs1 in edit.image" v-if="edit.title=='Update trip'">
          <a
            :href="`${i_url}${edit.tripID}/${edit.tripType}/${edit.imageType}/${edit.captureType}/${imgs1}`"
            target="_blank"
          >
            <img
              :src="`${i_url}${edit.tripID}/${edit.tripType}/${edit.imageType}/${edit.captureType}/${imgs1}`"
              style="height:50px; margin:2px; width:50px"
              alt="Not Available"
            />
          </a>

          <br />
          </div>-->
        </table>
        <div class="modal-footer">
          <button
            class="tablinks btn"
            style="color:white"
            @click="createTrip()"
            v-if="edit.title=='Create trip'"
          >Create</button>
          <button
            class="tablinks btn"
            style="color:white"
            @click="updateTrip()"
            v-if="edit.title=='Update trip'"
          >Update</button>
        </div>
      </div>
    </modal>

    <modal name="gasFlowDia" height="425">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
          <b>{{editGasFlow.title}}</b>
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="$modal.hide('gasFlowDia'); refreshTab();"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </h4>
      </div>

      <div class="modal-body">
        <table style="width:100%">
          <tr>
            <td>
              <label style="float: left">Trip Type:</label>
            </td>
            <td>
              <select v-model="editGasFlow.reading_1">
                <option value="startTrip">MS</option>
                <option value="endTrip">DBS</option>
              </select>
            </td>
          </tr>
          <br />
          <tr>
            <td>
              <label style="float: left">Capture Type:</label>
            </td>
            <td>
              <select v-model="editGasFlow.reading_2">
                <option value="pre">Initial</option>
                <option value="post">Final</option>
              </select>
            </td>
          </tr>
          <br />
          <tr>
            <td>
              <label style="float: left">Pressure Gauge Reading:</label>
            </td>
            <td>
              <input type="number" v-model="editGasFlow.reading_3" />
            </td>
          </tr>
          <br />
          <tr>
            <td>
              <label style="float: left">Gas Flow Meter Reading:</label>
            </td>
            <td>
              <input type="number" v-model="editGasFlow.reading_4" />
            </td>
          </tr>
          <br />
          <tr>
            <td>
              <label style="float: left">Recorded Time:</label>
            </td>
            <td>
              <datetime type="datetime" v-model="editGasFlow.reading_5" use12-hour></datetime>
            </td>
          </tr>
          <br />
          <tr>
            <div
              v-if="editGasFlow.title=='Add Gas Flow Details' && editGasFlow.reading_1 ==='startTrip' && editGasFlow.reading_2 ==='post'"
            >
              <td>
                <label style="float: left">Upload Challan:</label>
              </td>
              <td>
                <input
                  type="file"
                  @change="onFilechanged1"
                  class="form-control"
                  name="Upload Challan"
                />
              </td>
              <td>
                <field-messages name="Upload Challan" class="form-control-feedback"></field-messages>
              </td>

              <br />
            </div>
          </tr>
        </table>
        <div class="modal-footer">
          <button
            class="tablinks btn"
            style="color:white"
            @click="createGasFlowDetails()"
            v-if="editGasFlow.title=='Add Gas Flow Details'"
          >Create</button>
          <button
            class="tablinks btn"
            style="color:white"
            @click="updateGasFlowDetails()"
            v-if="editGasFlow.title=='Update Gas Flow Details'"
          >Update</button>
        </div>
      </div>
    </modal>
  </section>
</template>

<script>
import { formService, eventBus, tripService } from '../../../services';
import { EVENTS } from '../../../config';
import TripLocationLog from './TripLocationLog.vue';
import axios from 'axios';
import moment from 'moment';
import Config, { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';

export default {
  name: 'TripActivity',
  data() {
    return {
      edit: {},
      editGasFlow: {},
      trip_id: '',
      img_url: '',
      challan_img_url: `${Config.serverURI}/getMedia?path=trips`,
      i_url: `${Config.serverURI}/getMedia?path=trips/`,
      challanImage: '',
      urlId: '',
      USER_ROLES: USER_ROLES,
      loading: null,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: EVENTS,
      originReached: '',
      destinationReached: '',
      startedDate: '',
      endedDate: '',
      reportData: [
        {
          reading_1: '',
          reading_2: '',
          reading_3: '',
          reading_4: '',
          reading_5: '',
        },
      ],
      initialPressure: '',
      finalPressure: '',
      endFinalPressure: '',
      endInitialPressure: '',
      initialGas: '',
      finalGas: '',
      endFinalGas: '',
      endInitialGas: '',
      initialStartPressure: '',
      finalStartPressure: '',
      initialEndPressure: '',
      finalEndPressure: '',
      preStartGas: '',
      postStartGas: '',
      preEndGas: '',
      postEndGas: '',
      startOdoMeterReading: '',
      endOdoMeterReading: '',
      startRecordedTime: '',
      endRecordedTime: '',
      startTripTime: '',
      endTripTime: '',
      timeDifference: '',
      scheduledDate: '',
      tripExceptionTable: null,
      changedStatus: null,
      columns: [
        'recordedTime',
        'prevDestination',
        // 'batteryStatus',
        'divertedDestination',
        'originLocationDetails',
      ],
      options: {
        highlightMatches: true,
        sortable: [],
        headings: {
          recordedTime: 'Recorded Time',
          // batteryStatus: 'Battery Status',
          divertedDestination: 'Destination Change ',
          originLocationDetails: 'Original Location',
        },
        templates: {
          prevDestination(row, query) {
            if (
              query.prevDestinationDetails.length > 0 &&
              query.prevDestinationDetails[0]['siteName']
            ) {
              return `${query.prevDestinationDetails[0]['siteName']}`;
            }
          },
          divertedDestination(row, query) {
            if (
              query.divertedDestinationDetails.length > 0 &&
              query.divertedDestinationDetails[0]['siteName']
            ) {
              return `${query.divertedDestinationDetails[0]['siteName']}`;
            }
          },
          originLocationDetails(row, query) {
            if (
              query.originLocationDetails.length > 0 &&
              query.originLocationDetails[0]['siteName']
            ) {
              return `${query.originLocationDetails[0]['siteName']}`;
            }
          },
          recordedTime(row, query) {
            if (query.recordedTime) {
              return moment(query.recordedTime).format('DD-MM-YYYY HH:mm:ss');
            }
          },
        },
        requestFunction: request => {
          const params = {};
          params.$page = request.page;
          params.$limit = request.limit;
          params.docId = this.$route.params._id;
          this.loading = true;
          return this.$tripExceptionDataRepository.list(params).catch(error => {
            console.error('tripException.requestFunction-error:', error);
            this.$snotify.error('Get Exception', 'Error!');
          });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.result,
            count: response.data.result.length,
          };
        },
      },
      trip: {},
      //tripdetails : {}
      tripdetails: [],
      imageurls: [],
      challanImageUrls: [],
      odometer: [],
      gasfilling: [],
      pressure: [],
    };
  },
  mounted() {
    this.getTrip();
  },
  components: {
    TripLocationLog,
  },
  created() {
    axios({
      method: 'get',
      url: `${Config.serverURI}/challandetails?tripID=${this.$route.params._id}`,
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        console.log('response of challan', response);
        this.challanDetails =
          response.data &&
          response.data.docs &&
          response.data.docs.length > 0 &&
          response.data.docs[response.data.docs.length - 1];
        this.challanImage = this.challanDetails.image;
        this.urlId = this.challanDetails.tripID;
        response.data.docs.forEach(element => {
          element.image.forEach(imgUrl => {
            this.challanImageUrls.push(imgUrl);
          });
        });
      })
      .catch(e => {});
    axios({
      method: 'get',
      url: `${Config.serverURI}/tripdetails?tripID=${this.$route.params._id}`,
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        this.tripdetails = response.data.docs;

        this.startRecordedTime = response.data.docs.filter(
          obj => obj.tripType === 'startTrip' && obj.imageType === 'odometer',
        );
        this.endRecordedTime = response.data.docs.filter(
          obj => obj.tripType === 'endTrip' && obj.imageType === 'odometer',
        );
        this.initialPressure = response.data.docs.filter(
          obj =>
            obj.isDeleted === false &&
            obj.captureType === 'pre' &&
            obj.tripType === 'startTrip' &&
            obj.imageType === 'pressureMeter',
        );
        this.finalPressure = response.data.docs.filter(
          obj =>
            obj.isDeleted === false &&
            obj.captureType === 'post' &&
            obj.tripType === 'startTrip' &&
            obj.imageType === 'pressureMeter',
        );
        this.endInitialPressure = response.data.docs.filter(
          obj =>
            obj.isDeleted === false &&
            obj.captureType === 'pre' &&
            obj.tripType === 'endTrip' &&
            obj.imageType === 'pressureMeter',
        );
        this.endFinalPressure = response.data.docs.filter(
          obj =>
            obj.isDeleted === false &&
            obj.captureType === 'post' &&
            obj.tripType === 'endTrip' &&
            obj.imageType === 'pressureMeter',
        );
        this.initialGas = response.data.docs.filter(
          obj =>
            obj.isDeleted === false &&
            obj.captureType === 'pre' &&
            obj.tripType === 'startTrip' &&
            obj.imageType === 'gasFilling',
        );
        this.finalGas = response.data.docs.filter(
          obj =>
            obj.isDeleted === false &&
            obj.captureType === 'post' &&
            obj.tripType === 'startTrip' &&
            obj.imageType === 'gasFilling',
        );
        this.endInitialGas = response.data.docs.filter(
          obj =>
            obj.isDeleted === false &&
            obj.captureType === 'pre' &&
            obj.tripType === 'endTrip' &&
            obj.imageType === 'gasFilling',
        );
        this.endFinalGas = response.data.docs.filter(
          obj =>
            obj.isDeleted === false &&
            obj.captureType === 'post' &&
            obj.tripType === 'endTrip' &&
            obj.imageType === 'gasFilling',
        );

        if (
          this.initialPressure &&
          this.initialPressure.length &&
          this.initialGas &&
          this.initialGas.length
        ) {
          var iPressure = this.initialPressure[this.initialPressure.length - 1];
          var iGas = this.initialGas[this.initialGas.length - 1];
          this.reportData.splice(0, 1, {
            reading_1: iPressure.tripType,
            reading_2: iPressure.captureType,
            reading_3: iPressure.meterReading,
            reading_4: iGas.meterReading,
            reading_5:
              iGas.recordedTime &&
              moment(iGas.recordedTime).format('DD-MM-YYYY hh:mm A'),
          });
        }
        if (
          this.finalPressure &&
          this.finalPressure.length &&
          this.finalGas &&
          this.finalGas.length
        ) {
          var iPressure = this.finalPressure[this.finalPressure.length - 1];
          var iGas = this.finalGas[this.finalGas.length - 1];
          this.reportData.splice(1, 0, {
            reading_1: iPressure.tripType,
            reading_2: iPressure.captureType,
            reading_3: iPressure.meterReading,
            reading_4: iGas.meterReading,
            reading_5:
              iGas.recordedTime &&
              moment(iGas.recordedTime).format('DD-MM-YYYY hh:mm A'),
          });
        }
        if (
          this.endInitialPressure &&
          this.endInitialPressure.length &&
          this.endInitialGas &&
          this.endInitialGas.length
        ) {
          var iPressure = this.endInitialPressure[
            this.endInitialPressure.length - 1
          ];
          var iGas = this.endInitialGas[this.endInitialGas.length - 1];
          this.reportData.splice(2, 0, {
            reading_1: iPressure.tripType,
            reading_2: iPressure.captureType,
            reading_3: iPressure.meterReading,
            reading_4: iGas.meterReading,
            reading_5:
              iGas.recordedTime &&
              moment(iGas.recordedTime).format('DD-MM-YYYY hh:mm A'),
          });
        }
        if (
          this.endFinalPressure &&
          this.endFinalPressure.length &&
          this.endFinalGas &&
          this.endFinalGas.length
        ) {
          var iPressure = this.endFinalPressure[
            this.endFinalPressure.length - 1
          ];
          var iGas = this.endFinalGas[this.endFinalGas.length - 1];
          this.reportData.splice(3, 0, {
            reading_1: iPressure.tripType,
            reading_2: iPressure.captureType,
            reading_3: iPressure.meterReading,
            reading_4: iGas.meterReading,
            reading_5:
              iGas.recordedTime &&
              moment(iGas.recordedTime).format('DD-MM-YYYY hh:mm A'),
          });
        }
        this.odometer = response.data.docs.filter((re, index) => {
          if (re.imageType === 'odometer' && re.isDeleted == false) {
            response.data.docs[index]['recordedTime'] = moment(
              re['recordedTime'],
            ).format('DD-MM-YYYY hh:mm A');
            return true;
          }
        });
        this.startOdoMeterReading = response.data.docs.filter((re, index) => {
          if (re.imageType === 'odometer' && re.tripType === 'startTrip') {
            response.data.docs[index];
            return true;
          }
        });
        this.endOdoMeterReading = response.data.docs.filter((re, index) => {
          if (re.imageType === 'odometer' && re.tripType === 'endTrip') {
            response.data.docs[index];
            return true;
          }
        });
        this.gasfilling = response.data.docs.filter((re, index) => {
          if (
            re.imageType === 'gasFilling' ||
            re.imageType === 'pressureMeter'
          ) {
            if (re.imageType === 'gasFilling') {
              response.data.docs[index]['recordedTime'] = moment(
                re['recordedTime'],
              ).format('DD-MM-YYYY hh:mm A');
              return true;
            }
            if (re.imageType === 'pressureMeter') {
              response.data.docs[index]['recordedTime'] = moment(
                re['recordedTime'],
              ).format('DD-MM-YYYY hh:mm A');
              return true;
            }
          }
        });
        this.postStartGas = response.data.docs.filter((re, index) => {
          if (
            re.imageType === 'gasFilling' &&
            re.captureType === 'post' &&
            re.tripType === 'startTrip'
          ) {
            response.data.docs[index];
            return true;
          }
        });
        this.preStartGas = response.data.docs.filter((re, index) => {
          if (
            re.imageType === 'gasFilling' &&
            re.captureType === 'pre' &&
            re.tripType === 'startTrip'
          ) {
            response.data.docs[index];
            return true;
          }
        });
        this.postEndGas = response.data.docs.filter((re, index) => {
          if (
            re.imageType === 'gasFilling' &&
            re.captureType === 'post' &&
            re.tripType === 'endTrip'
          ) {
            response.data.docs[index];
            return true;
          }
        });
        this.preEndGas = response.data.docs.filter((re, index) => {
          if (
            re.imageType === 'gasFilling' &&
            re.captureType === 'pre' &&
            re.tripType === 'endTrip'
          ) {
            response.data.docs[index];
            return true;
          }
        });
        response.data.docs.forEach(element => {
          element.image.forEach(imgUrl => {
            this.imageurls.push(imgUrl);
          });
        });

        this.img_url = `${Config.serverURI}/getMedia?path=/trip/${this.$route.params._id}/`;
      })
      .catch(e => {
        console.log(e);
      });
  },
  filters: {
    capitalize: function(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  methods: {
    refreshTab() {
      this.odometer = [];
      this.tripdetails = [];
      this.challanDetails = [];
      this.challanDetails = {};
      this.reportData = [
        {
          reading_1: '',
          reading_2: '',
          reading_3: '',
          reading_4: '',
          reading_5: '',
        },
      ];
      axios({
        method: 'get',
        url: `${Config.serverURI}/tripdetails?tripID=${this.$route.params._id}`,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          this.tripdetails = response.data.docs;

          this.startRecordedTime = response.data.docs.filter(
            obj => obj.tripType === 'startTrip' && obj.imageType === 'odometer',
          );
          this.endRecordedTime = response.data.docs.filter(
            obj => obj.tripType === 'endTrip' && obj.imageType === 'odometer',
          );
          this.initialPressure = response.data.docs.filter(
            obj =>
              obj.isDeleted === false &&
              obj.captureType === 'pre' &&
              obj.tripType === 'startTrip' &&
              obj.imageType === 'pressureMeter',
          );
          this.finalPressure = response.data.docs.filter(
            obj =>
              obj.isDeleted === false &&
              obj.captureType === 'post' &&
              obj.tripType === 'startTrip' &&
              obj.imageType === 'pressureMeter',
          );
          this.endInitialPressure = response.data.docs.filter(
            obj =>
              obj.isDeleted === false &&
              obj.captureType === 'pre' &&
              obj.tripType === 'endTrip' &&
              obj.imageType === 'pressureMeter',
          );
          this.endFinalPressure = response.data.docs.filter(
            obj =>
              obj.isDeleted === false &&
              obj.captureType === 'post' &&
              obj.tripType === 'endTrip' &&
              obj.imageType === 'pressureMeter',
          );
          this.initialGas = response.data.docs.filter(
            obj =>
              obj.isDeleted === false &&
              obj.captureType === 'pre' &&
              obj.tripType === 'startTrip' &&
              obj.imageType === 'gasFilling',
          );
          this.finalGas = response.data.docs.filter(
            obj =>
              obj.isDeleted === false &&
              obj.captureType === 'post' &&
              obj.tripType === 'startTrip' &&
              obj.imageType === 'gasFilling',
          );
          this.endInitialGas = response.data.docs.filter(
            obj =>
              obj.isDeleted === false &&
              obj.captureType === 'pre' &&
              obj.tripType === 'endTrip' &&
              obj.imageType === 'gasFilling',
          );
          this.endFinalGas = response.data.docs.filter(
            obj =>
              obj.isDeleted === false &&
              obj.captureType === 'post' &&
              obj.tripType === 'endTrip' &&
              obj.imageType === 'gasFilling',
          );

          if (
            this.initialPressure &&
            this.initialPressure.length &&
            this.initialGas &&
            this.initialGas.length
          ) {
            var iPressure = this.initialPressure[
              this.initialPressure.length - 1
            ];
            var iGas = this.initialGas[this.initialGas.length - 1];
            this.reportData.splice(0, 1, {
              reading_1: iPressure.tripType,
              reading_2: iPressure.captureType,
              reading_3: iPressure.meterReading,
              reading_4: iGas.meterReading,
              reading_5:
                iGas.recordedTime &&
                moment(iGas.recordedTime).format('DD-MM-YYYY hh:mm A'),
            });
          }
          if (
            this.finalPressure &&
            this.finalPressure.length &&
            this.finalGas &&
            this.finalGas.length
          ) {
            var iPressure = this.finalPressure[this.finalPressure.length - 1];
            var iGas = this.finalGas[this.finalGas.length - 1];
            this.reportData.splice(1, 0, {
              reading_1: iPressure.tripType,
              reading_2: iPressure.captureType,
              reading_3: iPressure.meterReading,
              reading_4: iGas.meterReading,
              reading_5:
                iGas.recordedTime &&
                moment(iGas.recordedTime).format('DD-MM-YYYY hh:mm A'),
            });
          }
          if (
            this.endInitialPressure &&
            this.endInitialPressure.length &&
            this.endInitialGas &&
            this.endInitialGas.length
          ) {
            var iPressure = this.endInitialPressure[
              this.endInitialPressure.length - 1
            ];
            var iGas = this.endInitialGas[this.endInitialGas.length - 1];
            this.reportData.splice(2, 0, {
              reading_1: iPressure.tripType,
              reading_2: iPressure.captureType,
              reading_3: iPressure.meterReading,
              reading_4: iGas.meterReading,
              reading_5:
                iGas.recordedTime &&
                moment(iGas.recordedTime).format('DD-MM-YYYY hh:mm A'),
            });
          }
          if (
            this.endFinalPressure &&
            this.endFinalPressure.length &&
            this.endFinalGas &&
            this.endFinalGas.length
          ) {
            var iPressure = this.endFinalPressure[
              this.endFinalPressure.length - 1
            ];
            var iGas = this.endFinalGas[this.endFinalGas.length - 1];
            this.reportData.splice(3, 0, {
              reading_1: iPressure.tripType,
              reading_2: iPressure.captureType,
              reading_3: iPressure.meterReading,
              reading_4: iGas.meterReading,
              reading_5:
                iGas.recordedTime &&
                moment(iGas.recordedTime).format('DD-MM-YYYY hh:mm A'),
            });
          }
          this.odometer = response.data.docs.filter((re, index) => {
            if (re.imageType === 'odometer' && re.isDeleted == false) {
              response.data.docs[index]['recordedTime'] = moment(
                re['recordedTime'],
              ).format('DD-MM-YYYY hh:mm A');
              return true;
            }
          });
          this.startOdoMeterReading = response.data.docs.filter((re, index) => {
            if (re.imageType === 'odometer' && re.tripType === 'startTrip') {
              response.data.docs[index];
              return true;
            }
          });
          this.endOdoMeterReading = response.data.docs.filter((re, index) => {
            if (re.imageType === 'odometer' && re.tripType === 'endTrip') {
              response.data.docs[index];
              return true;
            }
          });
          this.gasfilling = response.data.docs.filter((re, index) => {
            if (
              re.imageType === 'gasFilling' ||
              re.imageType === 'pressureMeter'
            ) {
              if (re.imageType === 'gasFilling') {
                response.data.docs[index]['recordedTime'] = moment(
                  re['recordedTime'],
                ).format('DD-MM-YYYY hh:mm A');
                return true;
              }
              if (re.imageType === 'pressureMeter') {
                response.data.docs[index]['recordedTime'] = moment(
                  re['recordedTime'],
                ).format('DD-MM-YYYY hh:mm A');
                return true;
              }
            }
          });
          this.postStartGas = response.data.docs.filter((re, index) => {
            if (
              re.imageType === 'gasFilling' &&
              re.captureType === 'post' &&
              re.tripType === 'startTrip'
            ) {
              response.data.docs[index];
              return true;
            }
          });
          this.preStartGas = response.data.docs.filter((re, index) => {
            if (
              re.imageType === 'gasFilling' &&
              re.captureType === 'pre' &&
              re.tripType === 'startTrip'
            ) {
              response.data.docs[index];
              return true;
            }
          });
          this.postEndGas = response.data.docs.filter((re, index) => {
            if (
              re.imageType === 'gasFilling' &&
              re.captureType === 'post' &&
              re.tripType === 'endTrip'
            ) {
              response.data.docs[index];
              return true;
            }
          });
          this.preEndGas = response.data.docs.filter((re, index) => {
            if (
              re.imageType === 'gasFilling' &&
              re.captureType === 'pre' &&
              re.tripType === 'endTrip'
            ) {
              response.data.docs[index];
              return true;
            }
          });
          response.data.docs.forEach(element => {
            element.image.forEach(imgUrl => {
              this.imageurls.push(imgUrl);
            });
          });

          this.img_url = `${Config.serverURI}/getMedia?path=/trip/${this.$route.params._id}/`;
        })
        .catch(e => {
          console.log(e);
        });
    },

    onFilechanged(event) {
      this.edit.image = event.target.files[0];
      // this.edit.image = event.target.files[0]['name'];
    },

    onFilechanged1(event) {
      this.editGasFlow.image = event.target.files[0];
      // this.edit.image = event.target.files[0]['name'];
    },

    openNewTripDia() {
      this.edit = {};
      this.edit.title = 'Create trip';
      this.$modal.show('tripDialog');
    },
    createTrip() {
      this.edit.captureType =
        this.edit.tripType === 'startTrip' ? 'post' : 'pre';

      this.edit.tripID = this.trip._id;

      let formData = new FormData();
      formData.append('captureType', this.edit.captureType);
      formData.append('imageType', 'odometer');
      formData.append('tripID', this.trip._id);
      formData.append('latitude', this.edit.latitude);
      formData.append('longitude', this.edit.longitude);
      formData.append('meterReading', this.edit.meterReading);
      formData.append('recordedTime', this.edit.recordedTime);
      formData.append('tripType', this.edit.tripType);
      formData.append('file', this.edit.image);
      axios
        .post('/meterCapture', formData)
        .then(res => {
          this.odometer = []; 
          this.$modal.hide('tripDialog');
          this.$snotify.success('Trip created!', 'Success!');
          this.refreshTab();
        })

        .catch(err => {
          console.log('errorrrrr', err);
        });
    },

    openUpdateTripDia(o) {
      this.edit = {};
      this.edit = o;
      this.edit.title = 'Update trip';
      this.$modal.show('tripDialog');
    },

    updateTrip() {
      this.edit.image = document.getElementById('myfile');
      this.edit.captureType =
        this.edit.tripType === 'startTrip' ? 'post' : 'pre';
      this.edit.tripID = this.trip._id;

      let formData = new FormData();
      formData.append('captureType', this.edit.captureType);
      formData.append('imageType', 'odometer');
      formData.append('tripID', this.trip._id);
      formData.append('latitude', this.edit.latitude);
      formData.append('longitude', this.edit.longitude);
      formData.append('meterReading', this.edit.meterReading);
      formData.append('recordedTime', this.edit.recordedTime);
      formData.append('tripType', this.edit.tripType);
      // formData.append('image', ['asd']);
      axios
        .post('/meterCapture', formData)
        .then(res => {
          this.$modal.hide('tripDialog');
          this.$snotify.success('Trip updated!', 'Success!');
          this.refreshTab();
        })

        .catch(err => {
          console.log('errorrrrr', err);
        });
    },

    deleteTripDetail(data) {
      const body = { "hardDelete": true } 
      axios
        .delete(`/tripdetails/${data._id}`, body) 
        .then(res => {
          console.log('88888', res);
          this.$snotify.success('Trip deleted!', 'Success!');
          this.refreshTab();
        })
        .catch(err => {
          console.log('errorrrrrr', err);
        });
    },

    openNewGasFlowDia() {
      this.editGasFlow = {};
      this.editGasFlow.title = 'Add Gas Flow Details';
      this.$modal.show('gasFlowDia');
    },

    createGasFlowDetails() {
      let formData = new FormData();
      formData.append('captureType', this.editGasFlow.reading_2);
      formData.append('tripID', this.trip._id);
      formData.append('latitude', 7);
      formData.append('longitude', 7);
      formData.append('recordedTime', this.editGasFlow.reading_5);
      formData.append('tripType', this.editGasFlow.reading_1);

      formData.append('meterReading', this.editGasFlow.reading_3);
      formData.append('imageType', 'pressureMeter');

      axios
        .post('/meterCapture', formData)
        .then(res => {
          formData.set('meterReading', this.editGasFlow.reading_4);
          formData.set('imageType', 'gasFilling');
          axios
            .post('/meterCapture', formData)
            .then(res => {
              formData.append('file', this.editGasFlow.image);

              axios
                .post('/meterCapture', formData)
                .then(res => {})
                .catch(err => {
                  console.log('errorrrrr', err);
                });

              this.$modal.hide('gasFlowDia');
              this.$snotify.success('created!', 'Success!');
              this.tripdetails = [];
              this.challanDetails = [];
              this.challanDetails = {};
              this.reportData = [
                {
                  reading_1: '',
                  reading_2: '',
                  reading_3: '',
                  reading_4: '',
                  reading_5: '',
                },
              ];
              this.refreshTab();
            })
            .catch(err => {
              console.log('errorrrrr', err);
            });
        })
        .catch(err => {
          console.log('errorrrrr', err);
        });
    },

    openUpdateGasFlowDia(data) {
      this.ids = null;
      this.editGasFlow = {};
      this.editGasFlow = data;
      this.editGasFlow.title = 'Update Gas Flow Details';
      this.ids = this.tripdetails.filter(element => {
        return (
          element.captureType === data.reading_2 &&
          element.tripType === data.reading_1 &&
          (element.imageType === 'gasFilling' ||
            element.imageType === 'pressureMeter')
        );
      });
      this.$modal.show('gasFlowDia');
    },

    updateGasFlowDetails() {
      let formData = new FormData();
      formData.append('captureType', this.editGasFlow.reading_2);
      formData.append('tripID', this.trip._id);
      formData.append('latitude', 7);
      formData.append('longitude', 7);
      formData.append('recordedTime', this.editGasFlow.reading_5);
      formData.append('tripType', this.editGasFlow.reading_1);

      formData.append('meterReading', this.editGasFlow.reading_3);
      formData.append('imageType', 'pressureMeter');

      axios
        .post('/meterCapture', formData)
        .then(res => {
          formData.set('meterReading', this.editGasFlow.reading_4);
          formData.set('imageType', 'gasFilling');
          axios
            .post('/meterCapture', formData)
            .then(res => {
              this.$modal.hide('gasFlowDia');
              this.$snotify.success('created!', 'Success!');
              this.tripdetails = [];
              this.challanDetails = [];
              this.challanDetails = {};
              this.reportData = [
                {
                  reading_1: '',
                  reading_2: '',
                  reading_3: '',
                  reading_4: '',
                  reading_5: '',
                },
              ];
              this.refreshTab();
            })
            .catch(err => {
              console.log('errorrrrr', err);
            });
        })
        .catch(err => {
          console.log('errorrrrr', err);
        });
    },

    changeStatus(e) {
      this.changedStatus = e.target.value;
    },

    deleteopenUpdateGasFlowDia(data) {
      const ids = this.tripdetails.filter(element => {
        return (
          element.captureType === data.reading_2 &&
          element.tripType === data.reading_1 &&
          (element.imageType === 'gasFilling' ||
            element.imageType === 'pressureMeter')
        );
      });
      ids.forEach((i, ind) => {
        const body = { "hardDelete": true }
        axios
          .delete(`/tripdetails/${i._id}`, body)
          .then(res => {
            if (ind === ids.length - 1) {
              this.tripdetails = [];
              this.challanDetails = [];
              this.challanDetails = {};
              this.reportData = [
                {
                  reading_1: '',
                  reading_2: '',
                  reading_3: '',
                  reading_4: '',
                  reading_5: '',
                },
              ];
              axios({
                method: 'get',
                url: `${Config.serverURI}/tripdetails?tripID=${this.$route.params._id}`,
                headers: {
                  'Content-Type': 'application/json',
                },
              })
                .then(response => {
                  this.$snotify.success('Trip deleted!', 'Success!');
                  this.tripdetails = response.data.docs;

                  this.startRecordedTime = response.data.docs.filter(
                    obj =>
                      obj.tripType === 'startTrip' &&
                      obj.imageType === 'odometer',
                  );
                  this.endRecordedTime = response.data.docs.filter(
                    obj =>
                      obj.tripType === 'endTrip' &&
                      obj.imageType === 'odometer',
                  );
                  this.initialPressure = response.data.docs.filter(
                    obj =>
                      obj.isDeleted === false &&
                      obj.captureType === 'pre' &&
                      obj.tripType === 'startTrip' &&
                      obj.imageType === 'pressureMeter',
                  );
                  this.finalPressure = response.data.docs.filter(
                    obj =>
                      obj.isDeleted === false &&
                      obj.captureType === 'post' &&
                      obj.tripType === 'startTrip' &&
                      obj.imageType === 'pressureMeter',
                  );
                  this.endInitialPressure = response.data.docs.filter(
                    obj =>
                      obj.isDeleted === false &&
                      obj.captureType === 'pre' &&
                      obj.tripType === 'endTrip' &&
                      obj.imageType === 'pressureMeter',
                  );
                  this.endFinalPressure = response.data.docs.filter(
                    obj =>
                      obj.isDeleted === false &&
                      obj.captureType === 'post' &&
                      obj.tripType === 'endTrip' &&
                      obj.imageType === 'pressureMeter',
                  );
                  this.initialGas = response.data.docs.filter(
                    obj =>
                      obj.isDeleted === false &&
                      obj.captureType === 'pre' &&
                      obj.tripType === 'startTrip' &&
                      obj.imageType === 'gasFilling',
                  );
                  this.finalGas = response.data.docs.filter(
                    obj =>
                      obj.isDeleted === false &&
                      obj.captureType === 'post' &&
                      obj.tripType === 'startTrip' &&
                      obj.imageType === 'gasFilling',
                  );
                  this.endInitialGas = response.data.docs.filter(
                    obj =>
                      obj.isDeleted === false &&
                      obj.captureType === 'pre' &&
                      obj.tripType === 'endTrip' &&
                      obj.imageType === 'gasFilling',
                  );
                  this.endFinalGas = response.data.docs.filter(
                    obj =>
                      obj.isDeleted === false &&
                      obj.captureType === 'post' &&
                      obj.tripType === 'endTrip' &&
                      obj.imageType === 'gasFilling',
                  );

                  if (
                    this.initialPressure &&
                    this.initialPressure.length &&
                    this.initialGas &&
                    this.initialGas.length
                  ) {
                    var iPressure = this.initialPressure[
                      this.initialPressure.length - 1
                    ];
                    var iGas = this.initialGas[this.initialGas.length - 1];
                    this.reportData = [
                      {
                        reading_1: '',
                        reading_2: '',
                        reading_3: '',
                        reading_4: '',
                        reading_5: '',
                      },
                    ];
                    this.reportData.splice(0, 1, {
                      reading_1: iPressure.tripType,
                      reading_2: iPressure.captureType,
                      reading_3: iPressure.meterReading,
                      reading_4: iGas.meterReading,
                      reading_5:
                        iGas.recordedTime &&
                        moment(iGas.recordedTime).format('DD-MM-YYYY hh:mm A'),
                    });
                  }
                  if (
                    this.finalPressure &&
                    this.finalPressure.length &&
                    this.finalGas &&
                    this.finalGas.length
                  ) {
                    var iPressure = this.finalPressure[
                      this.finalPressure.length - 1
                    ];
                    var iGas = this.finalGas[this.finalGas.length - 1];
                    this.reportData.splice(1, 0, {
                      reading_1: iPressure.tripType,
                      reading_2: iPressure.captureType,
                      reading_3: iPressure.meterReading,
                      reading_4: iGas.meterReading,
                      reading_5:
                        iGas.recordedTime &&
                        moment(iGas.recordedTime).format('DD-MM-YYYY hh:mm A'),
                    });
                  }
                  if (
                    this.endInitialPressure &&
                    this.endInitialPressure.length &&
                    this.endInitialGas &&
                    this.endInitialGas.length
                  ) {
                    var iPressure = this.endInitialPressure[
                      this.endInitialPressure.length - 1
                    ];
                    var iGas = this.endInitialGas[
                      this.endInitialGas.length - 1
                    ];
                    this.reportData.splice(2, 0, {
                      reading_1: iPressure.tripType,
                      reading_2: iPressure.captureType,
                      reading_3: iPressure.meterReading,
                      reading_4: iGas.meterReading,
                      reading_5:
                        iGas.recordedTime &&
                        moment(iGas.recordedTime).format('DD-MM-YYYY hh:mm A'),
                    });
                  }
                  if (
                    this.endFinalPressure &&
                    this.endFinalPressure.length &&
                    this.endFinalGas &&
                    this.endFinalGas.length
                  ) {
                    var iPressure = this.endFinalPressure[
                      this.endFinalPressure.length - 1
                    ];
                    var iGas = this.endFinalGas[this.endFinalGas.length - 1];
                    this.reportData.splice(3, 0, {
                      reading_1: iPressure.tripType,
                      reading_2: iPressure.captureType,
                      reading_3: iPressure.meterReading,
                      reading_4: iGas.meterReading,
                      reading_5:
                        iGas.recordedTime &&
                        moment(iGas.recordedTime).format('DD-MM-YYYY hh:mm A'),
                    });
                  }
                  this.odometer = response.data.docs.filter((re, index) => {
                    if (re.imageType === 'odometer' && re.isDeleted == false) {
                      response.data.docs[index]['recordedTime'] = moment(
                        re['recordedTime'],
                      ).format('DD-MM-YYYY hh:mm A');
                      return true;
                    }
                  });
                  this.startOdoMeterReading = response.data.docs.filter(
                    (re, index) => {
                      if (
                        re.imageType === 'odometer' &&
                        re.tripType === 'startTrip'
                      ) {
                        response.data.docs[index];
                        return true;
                      }
                    },
                  );
                  this.endOdoMeterReading = response.data.docs.filter(
                    (re, index) => {
                      if (
                        re.imageType === 'odometer' &&
                        re.tripType === 'endTrip'
                      ) {
                        response.data.docs[index];
                        return true;
                      }
                    },
                  );
                  this.gasfilling = response.data.docs.filter((re, index) => {
                    if (
                      re.imageType === 'gasFilling' ||
                      re.imageType === 'pressureMeter'
                    ) {
                      if (re.imageType === 'gasFilling') {
                        response.data.docs[index]['recordedTime'] = moment(
                          re['recordedTime'],
                        ).format('DD-MM-YYYY hh:mm A');
                        return true;
                      }
                      if (re.imageType === 'pressureMeter') {
                        response.data.docs[index]['recordedTime'] = moment(
                          re['recordedTime'],
                        ).format('DD-MM-YYYY hh:mm A');
                        return true;
                      }
                    }
                  });
                  this.postStartGas = response.data.docs.filter((re, index) => {
                    if (
                      re.imageType === 'gasFilling' &&
                      re.captureType === 'post' &&
                      re.tripType === 'startTrip'
                    ) {
                      response.data.docs[index];
                      return true;
                    }
                  });
                  this.preStartGas = response.data.docs.filter((re, index) => {
                    if (
                      re.imageType === 'gasFilling' &&
                      re.captureType === 'pre' &&
                      re.tripType === 'startTrip'
                    ) {
                      response.data.docs[index];
                      return true;
                    }
                  });
                  this.postEndGas = response.data.docs.filter((re, index) => {
                    if (
                      re.imageType === 'gasFilling' &&
                      re.captureType === 'post' &&
                      re.tripType === 'endTrip'
                    ) {
                      response.data.docs[index];
                      return true;
                    }
                  });
                  this.preEndGas = response.data.docs.filter((re, index) => {
                    if (
                      re.imageType === 'gasFilling' &&
                      re.captureType === 'pre' &&
                      re.tripType === 'endTrip'
                    ) {
                      response.data.docs[index];
                      return true;
                    }
                  });
                  response.data.docs.forEach(element => {
                    element.image.forEach(imgUrl => {
                      this.imageurls.push(imgUrl);
                    });
                  });

                  this.img_url = `${Config.serverURI}/getMedia?path=/trip/${this.$route.params._id}/`;
                })
                .catch(e => {
                  console.log(e);
                });
            }
          })
          .catch(err => {
            console.log('errorrrrr', err);
          });
      });
    },

    tripEnd(action) {
      if (action == 'end') {
        (this.trip.status = 'completed'),
          (this.trip.endDate = new Date(Date.now()).toISOString());
        console.log('trip trip triup', this.trip);
      } else if (action == 'cancel') {
        this.trip.status = 'cancelled';
      }
      if (this.changedStatus != null) {
        this.trip.status = this.changedStatus;
      }

      this.loading = true;
      return tripService
        .updateTrip(this.trip)
        .then(response => {
          this.loading = false;
          this.flash = false;
          if (action == 'end') {
            this.$snotify.success('Trip is ended!', 'Success!');
            this.$router.push('/trip');
          } else if (action == 'cancel') {
            this.$snotify.success('Trip is cancelled!', 'Success!');
            this.$router.push('/trip');
          } else if (this.changeStatus != null && action == 'update') {
            window.location.reload();
            this.$snotify.success('Trip updated!', 'Success!');
            this.$router.push('/trip');
          } else if (action == 'update' && this.changeStatus == null) {
            this.$snotify.success('Trip timings are updated!', 'Success!');
          }
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Trip end failed', 'Error!');
          if (error.data.message.includes('must be one of')) {
            this.flash = true;
            this.flashType = 'error';
            this.flashMessage =
              'Trip is not updated due to some error. Please try again!.';
          }
        });
    },
    convertMS(ms) {
      var d, h, m, s;
      s = Math.floor(ms / 1000);
      m = Math.floor(s / 60);
      s = s % 60;
      h = Math.floor(m / 60);
      m = m % 60;
      d = Math.floor(h / 24);
      h = h % 24;
      h += d * 24;
      if (this.trip.destinationReachedAt < this.trip.startDate) {
        return (
          ('-'(h + '').length === 1 ? '0' + h : h) +
          ' h ' +
          ('0' + m).substr(-2) +
          ' min ' +
          ('0' + s).substr(-2)
        );
      } else {
        return (
          ((h + '').length === 1 ? '0' + h : h) +
          ' h ' +
          ('0' + m).substr(-2) +
          ' min ' +
          ('0' + s).substr(-2)
        );
      }
    },
    getTrip() {
      return this.$tripDataRepository
        .find(this.$route.params._id)
        .then(response => {
          console.log('this.trip', response);
          this.trip = response.data;
          this.scheduledDate =
            this.trip.scheduleDate &&
            moment(this.trip.scheduleDate).format('DD-MM-YYYY');
          this.endedDate =
            this.trip.endDate &&
            moment(this.trip.endDate).format('DD-MM-YYYY hh:mm A');
          this.startedDate =
            this.trip.startDate &&
            moment(this.trip.startDate).format('DD-MM-YYYY hh:mm A');
          this.destinationReached =
            this.trip.destinationReachedAt &&
            moment(this.trip.destinationReachedAt).format('DD-MM-YYYY hh:mm A');
          this.originReached =
            this.trip.originReachedAt &&
            moment(this.trip.originReachedAt).format('DD-MM-YYYY hh:mm A');
          if (this.trip.startDate && this.trip.destinationReachedAt) {
            this.timeDifference = this.convertMS(
              Math.abs(
                moment(this.trip.destinationReachedAt) -
                  moment(this.trip.startDate),
              ),
            );
          }
        })
        .catch(error => {
          this.$snotify.error(' OnGoing Trip detail failed', 'Error!');
        });
    },
    locationLogTable() {
      var x = document.getElementById('tripLocationLogTable');
      if (x.style.display === 'none') {
        x.style.display = 'block';
      } else {
        x.style.display = 'none';
      }
    },
    exceptionTable() {
      var y = document.getElementById('exceptionTable');
      if (y.style.display === 'none') {
        y.style.display = 'block';
      } else {
        y.style.display = 'none';
      }
    },
    onLoaded() {
      this.tripExceptionTable = this.$refs.tripExceptionTable;
    },
  },
  computed: {
    addButtonClass() {
      if (this.tripExceptionTable) {
        return this.tripExceptionTable.count > this.tripExceptionTable.limit ||
          this.tripExceptionTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
  },
};
</script>

<style scoped>
.table {
  padding: 20px;
}
table > tr > th {
  margin: 20px;
}
.box-header {
  background-image: linear-gradient(
    to right,
    rgba(38, 153, 251),
    rgba(146, 205, 255)
  );
}
.dropdown-toggle {
  background-color: rgba(255, 132, 78);
}
.tablinks {
  background-image: linear-gradient(
    to right,
    rgba(38, 153, 251),
    rgba(146, 205, 255)
  );
}
th {
  padding-left: 20px;
}
.trip-detail-tbl td,
th {
  padding: 4px 15px !important;
}

/deep/ .tripModal .v--modal-box {
  min-height: 500px !important;
  max-height: 500px !important;
  height: 500px !important;
  overflow-y: scroll !important;
}
</style>










// WEBPACK FOOTER //
// TripActivity.vue?e03d20b2